import React from 'react'
import  './styles/Toast.scss'
import closeImage from '../../images/icons/close_white.svg';

const Toast = (props) => {
  let {toasts, closeToast} = props;
  return toasts.length ? <div className="toast-container">
      {toasts.map((toast, i) => <div key={`toast-${i}`} className="toast">
        <b>{toast.title}</b>
        <p>{toast.body}</p>
        <a onClick={() => {
              closeToast(i)
            }
          } style={{
            position: 'absolute',
            top: 0,
            right:0
          }}  className="link"><img className="close" alt="Close" src={closeImage} /></a>
      </div>)}
    </div>
    :
    null;

}

Toast.defaultProps = {
  toasts: [],
  closeToast: null
}

export default Toast;



// WEBPACK FOOTER //
// ./src/components/ui/Toast.jsx